/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.ChosenFiltersRowView = app.View.extend({
    el: '.chosen-filters-row',
    events: {
      'click .filter-flag-rm': 'dropFilter',
      'click .clear-filters': 'dropAllFilters',
      'click .filter-flag': 'chooseSection',
    },
    wrapped: true,
    checkboxPriceValues: [
      'agg_is_ten',
      'agg_is_twenty',
      'agg_is_thirty',
    ],
    sectionsWithoutPopup: [
      'car_filter',
      'category',
      'agg_has_discount',
      'agg_is_novelty',
      'agg_is_hit',
      'agg_is_wholesale',
      'agg_is_exclusive',
      'agg_is_markdown',
      'condition',
    ],
    additionalOptions: [
      'collection',
      'filtersView',
      'filters',
      'activeFilterPageModel',
      'sectionsWithoutPopup',
      'isRootFilterPage',
    ],
    /**
     * @inheritDoc
     */
    run: function () {
      this.withHiddenAttrsPfs = false;
      this.listenTo(this.collection, 'sync', this.render);
      this.listenToOnce(this.model, 'reset', this.render);
      if (!app.isMobile) {
        this.delegateEvents(_.extend(this.events, {'click .overflowed': 'toggleChosenFiltersWrapper'}));
      }
      this.checkboxTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-checkbox-template');
      this.rangeTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-range-template');
      this.dropdownTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-dropdown-template');
      this.overflowedQtyTemplate = app.helpers.TemplateHelper.getTemplate('#overflowed-qty-template');
      this.wrapper = this.$('.filter-flags-wrapper');
      if (!app.isMobile) {
        this.sectionTemplate = app.helpers.TemplateHelper.getTemplate('#filters-row-section-template');
        this.popup = new app.ChosenFiltersPopupView({
          el: this.$('.chosen-filters-popup'),
          rowView: this,
          filtersView: this.filtersView,
          filters: this.filters,
          model: this.model,
        });
        this.listenTo(this.popup, 'update-filter', this.applyFilters);
        this.listenTo(this.popup, 'remove-active-flag', this.resetFlagActiveStatus);
        if (this.isRootFilterPage) {
          this.listenTo(this.activeFilterPageModel, 'change:base_url change:slug', this.handlePfsChange);
        }
      }
    },
    /**
     * @inheritDoc
     * @param collection - коллекция фильтров
     */
    render: function (collection) {
      this.stopListening(this.model, 'reset', this.render);
      if (!this.withHiddenAttrsPfs && (collection !== this.model || this.filtersView.fetchBoth)) {
        this.wrapper.html('');
        this.wrapper.addClass('wrapped');
        if (this.model.length) {
          _.each(this.model.models, function (filter) {
            this.renderSuitableTemplate(filter);
          }.bind(this));
          this.$el.removeClass('not_display');
          if (!app.isMobile) {
            this.wrapOverflowedFilters(this.wrapper);
          }
        } else {
          this.$el.addClass('not_display');
        }
        if (this.collection) {
          this.collection.resetFilterPageFilters();
        }
        Backbone.trigger('update-chosen-filters', this.model.countChosenFilters(), this.model, this.filters);

        this.listenToOnce(this.model, 'reset', this.render);
      }
    },

    /**
     * Обработка смены пфс страницы
     * @param {app.FilterPage} pfsModel - модель фильтра пфс страницы
     */
    handlePfsChange: function (pfsModel) {
      var pfsModelFilters = pfsModel.get('filters');
      if (pfsModelFilters) {
        var pfsFiltersKeys = Object.keys(pfsModel.get('filters'));
        // создана ли пфс по атрибуту не представленному в фильтрах
        var hiddenAttrsPfs = !_.some(Object.keys(this.filters.data), function (filterKey) {
          return pfsFiltersKeys.indexOf(filterKey) > -1;
        });
        if (hiddenAttrsPfs) {
          this.withHiddenAttrsPfs = true;
          this.wrapper.html('');
          this.wrapper.addClass('wrapped');
          this.renderSuitableTemplate(pfsModel);
          this.$el.removeClass('not_display');
        }
      }
    },

    /**
     * Применение фильтров
     * @param e
     * @param filterObj объект с фильтрами для применения
     * @param forceApply применить без попапа
     */
    applyFilters: function (e, filterObj, forceApply) {
      this.trigger('update-filter', e, filterObj, forceApply);
    },
    /**
     * Сбрасываем все фильтры
     */
    dropAllFilters: function () {
      this.popup.hidePopup(true);
      this.trigger('drop-all');
    },
    /**
     * Выбираем только выбранные значения в фильтре.
     * @param values
     * @returns {*}
     */
    findSelectedValues: function (values) {
      return _.filter(values, function (value) {
        return value.selected === true || _.has(value.values, 'max') || _.get(value, 'values.selected');
      });
    },
    /**
     * Выбор секции для открытия попапа
     * @param e
     */
    chooseSection: function (e) {
      if (!app.isMobile) {
        var target = $(e.currentTarget);
        var name = target.data('section-name');
        var toggle = false;
        if (this.popup.sectionName === name) {
          target.toggleClass('active');
          toggle = true;
        } else {
          this.$('.filter-flag').removeClass('active');
          target.addClass('active');
        }
        this.popup.sectionName = name;
        if (this.withHiddenAttrsPfs || _.includes(this.sectionsWithoutPopup, name)) {
          this.popup.hidePopup(false);
          target.removeClass('active');
        } else {
          this.trigger('choose-section', e, toggle);
        }
      }
    },
    /**
     * Сбрасывает активный статус флага при клике за пределами активных областей
     */
    resetFlagActiveStatus: function () {
      this.$('.filter-flag').removeClass('active');
    },
    /**
     * Обновляет выбранные фильтры.
     */
    forceUpdateChosenFilters: function () {
      this.filters.updateChosenFilters(this.model);
    },
    /**
     * Убрать секцию фильтров из выбранных
     * @param e
     * @param section
     */
    dropFiltersSection: function (e, section) {
      // если мы сбросили фильтры в попапе, вернется null
      var filterObj = this.getFilterObj() || {};
      this.popup.hidePopup(true);
      section = section.replace(/spec-\d/, '');
      delete filterObj[section];
      this.listenToOnce(this.collection, 'sync', this.forceUpdateChosenFilters);
      this.applyFilters(e, filterObj, true);
    },
    /**
     * Рендерим подходящий шаблон.
     * @param filter модель выбранного фильтра.
     */
    renderSuitableTemplate: function (filter) {
      var value = filter.get('name'),
        sectionName = filter.get('paramName'),
        qty = filter.get('selectedQty'),
        name = sectionName,
        withoutPopup = this.withHiddenAttrsPfs || _.includes(this.sectionsWithoutPopup, sectionName);

      var activeSection = this.popup.sectionName;
      if (withoutPopup) {
        var className = filter.get('class_name');
        qty = '';
        switch (className) {
          case 'Condition':
            name = 'condition';
            break;
          case 'Tree':
            try {
              value = this.findSelectedValues(filter.get('values'))[0].name;
            } catch (e) {
              if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
                Raven.captureException('Неверный параметр "f" на странице');
              } else {
                throw e;
              }
              value = '';
            }
            break;
        }
      }
      this.wrapper.append(this.sectionTemplate({
        sectionName: sectionName,
        name: name,
        value: value,
        qty: qty,
        isActive: activeSection === sectionName && !withoutPopup,
        withPopup: !withoutPopup,
      }));
    },
    /**
     * Сбрасываем выбранный фильтр.
     * @param e
     */
    dropFilter: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = $(e.currentTarget);
      var section = target.data('section');
      var shouldDropSection = !app.isMobile
        && !_.includes(this.sectionsWithoutPopup, section);
      if (this.withHiddenAttrsPfs) {
        this.dropAllFilters();
        this.withHiddenAttrsPfs = false;
        return;
      }
      if (shouldDropSection) {
        this.dropFiltersSection(e, section);
      } else {
        this.trigger('dropped-from-chosen-row');
        var id = target.data('id'),
          name = target.data('name'),
          filterObj = this.getFilterObj();

        this.listenToOnce(this.model, 'reset', this.render);
        this.trigger('dropped-filter-on-mobile');
        if (filterObj) {
          /**
           * Для range и select'ов
           */
          if (name && name !== 'condition') {
            delete(filterObj[name]);
            if (name === 'price') {
              this.checkboxPriceValues.forEach(function (value) {
                delete(filterObj[value]);
              });
            }
          }
          /**
           * Для чекбоксов
           */
          if (id) {
            var parsedId = id.split('-'),
              checkboxId = parsedId[1],
              sectionName = parsedId[0];
            if (checkboxId.indexOf('_') !== -1 && sectionName !== 'markers_filter'
              && sectionName !== 'price_filter' && sectionName !== 'agg_min_qty') {
              checkboxId = '"' + JSON.stringify(checkboxId.split('_').map(function (part) {
                return parseInt(part, 10);
              })) + '"';
            }
            if (sectionName !== 'markers_filter'
              && sectionName !== 'price_filter' && _.isArray(filterObj[sectionName])) {
              var index = filterObj[sectionName].indexOf(checkboxId);
              if (index === -1) {
                index = filterObj[sectionName].indexOf(parseInt(checkboxId, 10));
              }
              filterObj[sectionName].splice(index, 1);
              if (!filterObj[sectionName].length) {
                delete filterObj[sectionName];
              }
            } else {
              delete filterObj[checkboxId];
            }
          }
        }
        this.trigger('drop-one', e, filterObj);
      }
    },
    /**
     * Получает объект с активными фильтрами.
     * @returns {Object}
     */
    getFilterObj: function () {
      return this.collection.getFilter() || {};
    },
    /**
     * Сворачивает выбранные фильтры, если они занимают больше трех рядов.
     * @param wrapper
     */
    wrapOverflowedFilters: function (wrapper) {
      this.overflowedLength = app.helpers.DomHelper.getOverflowedElements(wrapper[0]).length;
      if (this.overflowedLength) {
        this.$('.overflowed-wrapper').html(this.overflowedQtyTemplate({
          wrapped: this.wrapped,
          overflowedQty: this.overflowedLength,
        }));
      } else {
        this.$('.overflowed-wrapper').html('');
      }
      if (!this.wrapped) {
        wrapper.removeClass('wrapped');
      }
    },
    /**
     * Переключатель режима свернутости выбранных фильтров.
     */
    toggleChosenFiltersWrapper: function () {
      this.wrapped = !this.wrapped;
      this.wrapper.toggleClass('wrapped');
      this.$('.overflowed-wrapper').html(this.overflowedQtyTemplate({
        wrapped: this.wrapped,
        overflowedQty: this.overflowedLength,
      }));
    },
  });
})();

}.call(window));